<template>
	<div class="confirmMessage">
		<b-modal
			class="confirm-modal"
			v-model="showModal"
			centered
			size="xl"
			hide-footer
			hide-header
			ref="confirm-modal"
		>
		<div class="confirm-modal-content">
			<div class="confirmMessage-style">
				<div class="style-shadow"></div>
			</div>
			<p>Are you sure you want to leave this page without saving any change?</p>
			<div class="content-buttons">
				<b-button @click="hideModal" class="cancel-button" style="margin: auto">
					<div class="button-style">
						<div class="style-shadow"></div>
					</div>
					<label class="button-text">Leave without saving</label>
				</b-button>
				<div class="vertical-line"></div>
				<b-button @click="confirm" class="confirm-button" style="margin: auto">
					<div class="button-style">
						<div class="style-shadow"></div>
					</div>
					<label class="button-text">Save changes and continue</label>
				</b-button>
			</div>
		</div>
		</b-modal>
	</div>
</template>

<script>
export default {

	props: {
		show: {
			type: Boolean,
			default: false
		},
		updateShow: {
			type: Function,
			default: ()=>{}
		},
		returnValue: {
			type: Function,
			default: ()=>{}
		}
	},
	data() {
		return {
			showModal: this.show
		}
	},
	watch: {
		showModal: function (val) {
			this.updateShow(val)
		},
		show: function (val) {
			this.showModal = val
		},
	},
	methods: {
      hideModal() {
		this.returnValue('continue')
		},
	  confirm() {
		  this.$refs['confirm-modal'].hide()
		  this.returnValue('save')
	  }
    }
};
</script>
<style scoped lang="scss">
* {
	position: relative;
	margin: 0;
	padding: 0;
}

.confirm-button {
	display: flex;
	background-color: #ffe27e;
	justify-content: center;
	align-items: center;
	padding: 0.4em 1.5em;
	transition: 150ms;
	border-radius: 10px;
	border: none;

	&:hover {
		transform: scale(1.1);
		cursor: pointer;
	}

	.button-style {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		overflow: hidden;
		border-radius: 10px;

		.style-shadow {
			background: #ffe27e;
			mix-blend-mode: multiply;
			position: absolute;
			width: 100%;
			height: 50%;
			border-bottom-left-radius: 100%;
			border-bottom-right-radius: 100%;
			opacity: 0.5;
		}
	}

	.button-text {
		color: black;
		text-align: center;

		&:hover {
			cursor: pointer;
		}
	}
}

.confirm-modal-content {
	position: absolute;
	background-color: white;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 1.25em;
	left: 0;
	top: -200%;
	width: 100%;
	min-height: 200px;
	border: none;
	border-radius: 20px;
	padding: 1rem;
	overflow: hidden;
	text-align: center;

	.confirmMessage-style {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		border-radius: 10px;
		.style-shadow {
			background: #E6F8D6;
			mix-blend-mode: multiply;
			position: absolute;
			// left: -12.5%;
			width: 100%;
			height: 45%;
			border-bottom-left-radius: 100%;
			border-bottom-right-radius: 100%;
		}
	}
	
	.content-buttons {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-evenly;
		align-items: center;
		gap: 1rem;
		width: 100%;

		.vertical-line {
			background-color: #2A2061;
			width: 2px;
			height: 100%;

			@media (max-width: 991px) {
				display: none;
			}
		}

		.cancel-button {
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: white;
			color: #2A2061;
			width: 45%;
			min-width: 300px;
			margin: 1rem;
			padding: 0.7rem;
			border: 1px solid #2A2061;
			border-radius: 10px;

			&:hover {
				background-color: #2A2061;
				color: white;
			}
		}

		.confirm-button {
			width: 45%;
			min-width: 300px;
			margin: 1rem;
			padding: 0.7rem;
		}
	}
}


 .modal-body{
	background-color: tomato;
	display: flex;
}
</style>
